import { render, staticRenderFns } from "./teambuying.vue?vue&type=template&id=405ddc0c&scoped=true"
import script from "./teambuying.vue?vue&type=script&lang=js"
export * from "./teambuying.vue?vue&type=script&lang=js"
import style0 from "./teambuying.vue?vue&type=style&index=0&id=405ddc0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405ddc0c",
  null
  
)

export default component.exports